export var getTimezoneDiff = function getTimezoneDiff(timezoneOffset) {
  var offset = new Date().getTimezoneOffset();
  return timezoneOffset * 60 + offset;
};